import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    id: String,
    name: String
  };

  connect() {
    const selectElement = document.querySelector('#job_client_company_id');

    if (selectElement && selectElement.selectize) {
      const selectize = selectElement.selectize;

      // Only add the option if it doesn't already exist
      if (!selectize.options[this.idValue]) {
        selectize.addOption({
          value: this.idValue,
          text: this.nameValue
        });
      }

      // Select the newly added company
      selectize.addItem(this.idValue);
    }

    // Remove this temporary element
    this.element.remove();
  }
}
